import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { ProducaoService } from '../services/api/Producao/ProducaoService';

type TAutoCompleteOption = {
  idproducao: string;
  label: string;
}

interface IAutoCompleteFazendaProps {
  isExternalLoading?: boolean;
  uuidproducao?: (novoTextoselect: string | undefined) => void;
  onConfSelecionado?: (idconf: string | undefined) => void;
}

export const AutoCompleteProdutividade: React.FC<IAutoCompleteFazendaProps> = ({
  isExternalLoading = false,
  uuidproducao,
  onConfSelecionado,
}) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idproducao');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);
  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      ProducaoService.getAlllist(selectedId, busca)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
          } else {
            setOpcoes(result.data.map(producao => ({ idproducao: producao.idproducao, label: producao.descricao })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;
    const selectedOption = opcoes.find(opcao => opcao.idproducao === selectedId);
    if (!selectedOption) return null;
    return selectedOption;
  }, [selectedId, opcoes]);

  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => {
        setSelectedId(newValue?.idproducao);
        uuidproducao?.(newValue?.idproducao);
        onConfSelecionado?.(newValue?.idproducao);
        setBusca('');
        clearError();
      }}
      popupIcon={isLoading ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Produção"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};